export const TOGGLE_STAFFENQUIRYFORM_MODAL = 'TOGGLE_STAFF_ENQUIRY_FORM_MODAL';

export const toggleStaffEnquiryForm = () => async (dispatch) => {
  dispatch({
    type: TOGGLE_STAFFENQUIRYFORM_MODAL,
  });
};
